module.exports = __webpack_public_path__ + "static/media/get_credit.web.b4b3a8df.png";